import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import List from "@mui/material/List";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { resources } from ".././Resourses/Resources";
import { Link, useNavigate } from "react-router-dom";
import "../Admissionprocedure/AcadamicCalender.css";
import DeleteIcon from "@mui/icons-material/Delete";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import Button from "@mui/material/Button";
import DialogEdit from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import PaginationReUsable from "../ReuseableComponent/ReusePagination";
import { User } from "lucide-react";
import { getUserInfo } from "../Authservice";
// import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

import "./commiteeFuctions.css";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function createData(name, calories, fat, carbs, protein, moredetails) {
  return { name, calories, fat, carbs, protein, moredetails };
}

export default function CustomizedTables({ Heading }) {
  const userRole = getUserInfo()?.roles[0];
  const isAdmin = userRole === "ROLE_MANAGEMENT";
  const [isEnable, setIsEnable] = useState(false);
  const [activeCommitte, setActiveCommitee] = useState([]);
  const [allCommitteData, setAllCommitteData] = useState([]);
  const [imgPath, setImgPath] = useState("");
  const [committeeName, setCommitteName] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [modify, setModify] = useState({});
  const [modifyDataMembers, setModifyDataMembers] = useState({});
  const [imagePath, setImagePath] = useState("");
  const [editableIndex, setEditableIndex] = useState("");
  const [search, setSearch] = useState("");
  const [serialNo, setSerialNo] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [paginationData, setPaginationData] = useState([]);
  const [selectedSection, setSelectedSection] = useState("Members");
  const [CommiteeResponse, setCommiteeResponse] = useState();
  const user = getUserInfo()?.roles[0];
  const [rowData, setRowData] = useState("");
  const [FuctionsData, setFunctionsData] = useState([]);
  const [headingList, setHeadingList] = useState([]);
  const navigate = useNavigate();
  const [openEdit, setOpenEdit] = React.useState(false);
  const [openEditMembers, setOpenEditMembers] = useState(false);

  const [heading, setHeading] = useState("");

  const [updatedFields, setUpdatedFields] = useState({});
  const [editingItem, setEditingItem] = useState(null);

  const handleEditContainer = (heading, index, contentObj) => {
    const key = `${heading}-${index}`;
    setEditingItem({ heading, index });

    setUpdatedFields((prev) => ({
      ...prev,
      [key]: {
        heading: contentObj.heading || "",
        type: contentObj.type || "",
        content: contentObj.content || "",
      },
    }));
  };

  const handleUpdate = async (heading, index) => {
    const stateKey = `${heading}-${index}`;
    const updatedText = updatedFields[stateKey];
    const item = FuctionsData[heading][index];

    console.log("headinggggggggggggggg", heading);
    console.log("item.....", item);
    console.log("updatedText...", updatedText);

    if (!item || !item.uniqueKey) {
      console.error("Missing uniqueKey or item:", item);
      return;
    }

    // const itemToUpdate=
    console.log("item_uniiiiiiiiiiiiiiii", item.uniqueKey);

    const updatePayload = {
      uniqueKey: item.uniqueKey,
      type: updatedText?.type || item.type,
      heading: updatedText?.heading || item.heading,
      content: updatedText?.content || item.content,
    };

    console.log("Sending payload:", updatePayload);

    try {
      const response = await axios.put(
        `${resources.APPLICATION_URL}committeeChild/updateCommitteeChild`,
        updatePayload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("responsepppppppppppppp", response);
      // .then((response)=>{
      //   console.log('responsePutData............',response.data)
      // })

      console.log("Update success:", response.data);

      await getCommiteFUnctions("Functions"); // Refetch data
      setEditingItem(null); // Close editor
    } catch (error) {
      console.error("Update failed:", error);
      if (error.response) {
        console.error("Server response:", error.response.data);
      }
    }
  };

  const handleClickForEdit = () => {
    setOpenEdit(true);
  };
  const handleClickOpenEdit = () => {
    setOpenEdit(true);
  };

  const handleCloseEdit = async () => {
    try {
      setOpenEdit(false);
      const res = await axios.post(
        resources.APPLICATION_URL + "edit/commitees",
        modify
      );
      if (res.status === 200) {
        console.log("edit", res);
        handlegetAllCommitteData();
        // alert("Data edited successfully");
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const handleCloseAndEdit = () => {
    setOpenEdit(false);
  };
  console.log("This is user======>", User);

  // comitte members edit
  const handleDeleteCommiteeMem = async (rid) => {
    try {
      const res = await axios.delete(
        resources.APPLICATION_URL + `delete/committe-members?cMemberId=${rid}`
      );
      if (res.data) {
        console.log("delete", res);
        handleClickForMoreDetails(committeeName, name, email);
      } else {
        alert("No data found");
      }
    } catch (e) {
      console.log(e);
    }
  };
  const handleClickForEditCommiteeMember = () => {
    setOpenEditMembers(true);
  };
  const handleEditSubmitCommMemmers = async () => {
    try {
      setOpenEditMembers(false);
      const res = await axios.post(
        resources.APPLICATION_URL + "edit/committe/members",
        modifyDataMembers
      );
      if (res.status === 200) {
        console.log("edit", res);

        setEditableIndex("");
        setModifyDataMembers({});
        handlegetAllCommitteData();
        alert("Data edited successfully");
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const handleEditCloseCommiteeMember = () => {
    setOpenEditMembers(false);
  };

  const handleClickForMoreDetails = async (param, nameCo, emailCo) => {
    console.log("params===>", param, nameCo, emailCo);
    console.log("param===>", param);
    setIsEnable(true);
    try {
      const res = await axios.get(
        resources.APPLICATION_URL +
          `getallcommittee/members/?committee=${param}`
      );
      console.log("respones-----s ", res);
      if (res.data) {
        console.log("getallcommittee/members/", res);
        setActiveCommitee(res.data[0]);
        setFilteredData(res.data[0]);
        setPaginationData(res.data[0]);
        setAllData(res.data[0]);
        setImagePath(res.data[1]);

        setCommitteName(param);
        setName(nameCo);
        setEmail(emailCo);
        setIsEnable(true);
      } else {
        // alert("No data found");
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleDeleteContent = async (id, type) => {
    try {
      const res = await axios.delete(
        `${resources.APPLICATION_URL}committeeChild/deleteCommitteeChild?uniqueKey=${id}`
      );
      alert("Data Deleted Successfully");
      console.log("response for delete", res);
      // getCommiteFUnctions();
      getCommiteFUnctions(type);
    } catch (e) {
      console.log("Not Deleted", e);
    }
  };

  const handlegetAllCommitteData = async () => {
    try {
      const res = await axios.get(
        resources.APPLICATION_URL + "get/all/committees"
      );
      console.log("Please check response......................", res.data);
      setAllCommitteData(res.data);
      /* (res.status===200) {
        console.log('..........');
        setAllCommitteData(res.data);
        console.log("committee members details===>", res.data);
      } else {
        alert("No data found");
      }*/
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    handlegetAllCommitteData();
  }, []);

  const handleClose = () => {
    setIsEnable(false);
  };
  const handleNavigate = () => {
    navigate("/feedback/greivences");
  };

  const getCommiteFUnctions = async (type) => {
    if (type === "Functions") {
      try {
        const response = await axios.get(
          resources.APPLICATION_URL +
            `committees/getCommitteeFunctionality?committeeType=${encodeURIComponent(
              rowData.committees
            )}&type=${encodeURIComponent(type)}`
        );
        console.log("functionsssss --->", response);
        if (response.data.data) {
          setFunctionsData(response.data.data);
          setHeadingList(response.data.data.headingsList);
        } else {
          // setFunctionsData([]);
          // setHeadingList([]);
        }
      } catch (e) {
        console.log("get Commitee Functions", e);
      }
    }

    if (type === "roles") {
      try {
        const response = await axios.get(
          resources.APPLICATION_URL +
            `committees/getCommitteeFunctionality?committeeType=${encodeURIComponent(
              rowData.committees
            )}&type=${encodeURIComponent(type)}`
        );
        // console.log("functionsssss --->", response)
        // setFunctionsData(response.data.data['Functions'])
        setFunctionsData(response.data.data);
        setHeadingList(response.data.data.headingsList);
      } catch (e) {
        console.log("get Commitee Functions", e);
      }
    }
  };

  const handleDelete = async (commiteeName) => {
    try {
      const res = await axios.delete(
        resources.APPLICATION_URL +
          `delete/committee?committeeName=${encodeURIComponent(commiteeName)}`
      );
      if (res.data) {
        console.log("delete", res);
        handlegetAllCommitteData();
      } else {
        alert("No data found");
      }
    } catch (e) {
      console.log(e);
    }
  };
  const handleSearch = (e) => {
    let { value } = e.target;
    console.log("value", value);

    let list = allData.filter(
      (each) =>
        (each.memberName &&
          each.memberName.toLowerCase().includes(value.toLowerCase())) ||
        (each.memberId &&
          each.memberId.toLowerCase().includes(value.toLowerCase()))
    );
    console.log("list==>", list);
    setFilteredData(list);
    setSearch(value);
  };
  const handleGetSpliceData = (receivedList, startSNo) => {
    setPaginationData(receivedList);
    setSerialNo(startSNo);
  };
  console.log("paginationData===>", paginationData);
  console.log("headingList.......", headingList);
  console.log("allCommitteData....", allCommitteData);
  return (
    <>
      {!isEnable && (
        <div>
          <div class="navbar navbar-expand-lg navbar-light ">
            <div class="container">
              <a class="navbar-brand" href="#">
                INSTITUTE LEVEL COMMITTEES
              </a>
            </div>
          </div>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell align="center">S.No</StyledTableCell>
                  <StyledTableCell align="center">
                    Committee Name
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    Committee Co-Ordinator{" "}
                  </StyledTableCell>
                  <StyledTableCell align="center">E-Mail</StyledTableCell>
                  <StyledTableCell align="center">
                    Mobile Number
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    Click Here for More Information
                  </StyledTableCell>
                  {/* <StyledTableCell align="center">
                  Action
                </StyledTableCell> */}
                  {user === "ROLE_MANAGEMENT" && (
                    <StyledTableCell align="center">Action</StyledTableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {allCommitteData &&
                  allCommitteData.length !== 0 &&
                  allCommitteData.map((row, index) => (
                    <StyledTableRow key={row.name}>
                      <StyledTableCell component="th" scope="row">
                        {index + 1}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {row.committees}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {row.cordinator}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {row.cordinatorEmail}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {row.cordinatorMobileNumber}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {
                          <button
                            style={{ border: "none", background: "none" }}
                            className="Committe_btn"
                            onClick={() => {
                              handleClickForMoreDetails(
                                row.committees,
                                row.cordinator,
                                row.cordinatorEmail
                              );
                              console.log("rowwwwww", row);
                              console.log("this is committe===", committeeName);
                              setRowData(row);
                            }}
                          >
                            Click Here For More Details
                          </button>
                        }
                      </StyledTableCell>
                      {user === "ROLE_MANAGEMENT" && (
                        <StyledTableCell align="center">
                          <EditOutlinedIcon
                            className="editIconCommitee"
                            onClick={() => {
                              handleClickForEdit();
                              setModify(row);
                            }}
                          ></EditOutlinedIcon>
                          <DeleteIcon
                            className="deleteIcon"
                            onClick={() => handleDelete(row.committees)}
                          />
                        </StyledTableCell>
                      )}
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      )}

      {isEnable && (
        <div>
          <div className="CommitteBackbtn">
            <button className="committe-Btn" onClick={() => setIsEnable(false)}>
              Back to commitee
            </button>
            <h2 style={{ marginLeft: "25%", color: "#FF4500" }}>
              {rowData.committees}
            </h2>
          </div>

          <div className="committeemainContainer">
            <div className="photo_container">
              <div className="photo_name_container">
                <button
                  onClick={() => handleNavigate()}
                  className="grevience_btn"
                >
                  Greviences
                </button>

                <Link
                  to="#"
                  className="function_style"
                  onClick={() => {
                    setSelectedSection("Functions");
                    getCommiteFUnctions("Functions");
                  }}
                >
                  Functions
                </Link>
                <Link
                  to="#"
                  className="function_style"
                  onClick={() => {
                    setSelectedSection("Roles & Responsibilites");
                    getCommiteFUnctions("roles");
                  }}
                >
                  Roles & Responsibilites
                </Link>
                <Link
                  to="#"
                  className="function_style"
                  onClick={() => setSelectedSection("Members")}
                >
                  Members
                </Link>
              </div>

              <div className="conver_container">
                <div className="conver_head_container">
                  <h1 className="conver_head">Convener</h1>
                </div>
                <img
                  id="displayedImage"
                  alt="Displayed Image"
                  src={`data:image/png;base64,${imagePath}`}
                  className="img_commitee"
                />

                <p className="function_style_name">{name}</p>
                <p className="function_style_name email">{email}</p>
              </div>
            </div>

            <div style={{ width: "65%" }}>
              {selectedSection === "Functions" && (
                <>
                  <div style={{ padding: "20px" }}>
                    {/* <h2>{FuctionsData[0]?.heading}</h2>
                    {
                      FuctionsData?.map(each => {
                        return (
                          <li className="Commitee_Roles_Content">{each.content}</li>
                        )
                      })
                    } */}

                    {headingList.map((heading, idx) => (
                      <div key={idx}>
                        <div style={{ display: "flex" }}>
                          <h3
                            onClick={() =>
                              setEditingItem({ heading, index: null })
                            }
                          >
                            {heading}
                          </h3>
                          {isAdmin && (
                            <>
                              &nbsp;&nbsp;&nbsp;
                              <span>
                                <EditOutlinedIcon
                                  onClick={() =>
                                    setEditingItem({ heading, index: null })
                                  }
                                  sx={{ color: "blue" }}
                                />
                              </span>
                            </>
                          )}
                        </div>

                        {FuctionsData[heading]?.map((contentObj, index) => {
                          const isEditing =
                            editingItem?.heading === heading &&
                            editingItem?.index === index;
                          console.log("isEditing----------.", isEditing);
                          const stateKey = `${heading}-${index}`;
                          const updatedText = updatedFields[stateKey];

                          console.log("contentObj......", contentObj);
                          console.log("updatedFields.......", updatedFields);
                          return (
                            <div key={contentObj.uniqueKey || index}>
                              {editingItem?.heading === heading &&
                              editingItem?.index === index ? (
                                <>
                                  {/* <input
                                        type="text"
                                        placeholder="Heading"
                                        value={updatedFields[`${heading}-${index}`]?.heading || ""}
                                        onChange={(e) =>
                                          setUpdatedFields((prev) => ({
                                            ...prev,
                                            [`${heading}-${index}`]: {
                                              ...prev[`${heading}-${index}`],
                                              heading: e.target.value
                                            }
                                          }))
                                        }
                                      />
                                      <input
                                        type="text"
                                        placeholder="Type"
                                        value={updatedFields[`${heading}-${index}`]?.type || ""}
                                        onChange={(e) =>
                                          setUpdatedFields((prev) => ({
                                            ...prev,
                                            [`${heading}-${index}`]: {
                                              ...prev[`${heading}-${index}`],
                                              type: e.target.value
                                            }
                                          }))
                                        }
                                      /> */}

                                  <textarea
                                    placeholder="Content"
                                    className="Main_TextArea_Commites"
                                    value={
                                      updatedFields[`${heading}-${index}`]
                                        ?.content || ""
                                    }
                                    onChange={(e) =>
                                      setUpdatedFields((prev) => ({
                                        ...prev,
                                        [`${heading}-${index}`]: {
                                          ...prev[`${heading}-${index}`],
                                          content: e.target.value,
                                        },
                                      }))
                                    }
                                  />
                                </>
                              ) : (
                                <li>{contentObj.content}</li>
                              )}

                              {isAdmin && (
                                <>
                                  {/* Show edit button only when heading is selected */}
                                  {editingItem?.heading === heading &&
                                    editingItem?.index === null && (
                                      <>
                                        <button
                                          onClick={() =>
                                            handleEditContainer(
                                              heading,
                                              index,
                                              contentObj
                                            )
                                          }
                                          className="Main_commitee_Functions_button"
                                        >
                                          Edit
                                        </button>
                                        <button
                                          onClick={() =>
                                            handleDeleteContent(
                                              contentObj.uniqueKey,
                                              "Functions"
                                            )
                                          }
                                          className="Main_commitee_Functions_Delete"
                                        >
                                          Delete
                                        </button>
                                      </>
                                    )}
                                </>
                              )}

                              {isEditing && (
                                <button
                                  onClick={() => handleUpdate(heading, index)}
                                  className="Main_Save_Button"
                                >
                                  Save
                                </button>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    ))}
                  </div>
                </>
              )}
              {selectedSection === "Roles & Responsibilites" && (
                <div style={{ padding: "20px" }}>
                  {headingList.map((heading, idx) => (
                    <div key={idx}>
                      <div style={{ display: "flex" }}>
                        <h3>{heading}</h3>
                        {isAdmin && (
                          <>
                            &nbsp;&nbsp;&nbsp;
                            <span>
                              <EditOutlinedIcon
                                onClick={() =>
                                  setEditingItem({ heading, index: null })
                                }
                                sx={{ color: "blue" }}
                              />
                            </span>
                          </>
                        )}
                      </div>

                      {FuctionsData[heading]?.map((item, index) => {
                        const isEditing =
                          editingItem?.heading === heading &&
                          editingItem?.index === index;

                        const stateKey = `${heading}-${index}`;
                        const updatedText = updatedFields[stateKey];

                        return (
                          <div key={item.uniqueKey || index}>
                            {isEditing ? (
                              <textarea
                                placeholder="Content"
                                className="Main_TextArea_Commites"
                                value={updatedText?.content || ""}
                                onChange={(e) =>
                                  setUpdatedFields((prev) => ({
                                    ...prev,
                                    [stateKey]: {
                                      ...prev[stateKey],
                                      content: e.target.value,
                                    },
                                  }))
                                }
                              />
                            ) : (
                              <ul>
                                <li>{item.content}</li>
                              </ul>
                            )}

                            {isAdmin && (
                              <>
                                {editingItem?.heading === heading &&
                                  editingItem?.index === null && (
                                    <>
                                      <button
                                        onClick={() =>
                                          handleEditContainer(
                                            heading,
                                            index,
                                            item
                                          )
                                        }
                                        className="Main_commitee_Functions_button"
                                      >
                                        Edit
                                      </button>

                                      <button
                                        onClick={() =>
                                          handleDeleteContent(
                                            item.uniqueKey,
                                            "roles"
                                          )
                                        }
                                        className="Main_commitee_Functions_Delete"
                                      >
                                        Delete
                                      </button>
                                    </>
                                  )}
                              </>
                            )}

                            {isEditing && (
                              <button
                                onClick={() => handleUpdate(heading, index)}
                                className="Main_Save_Button"
                              >
                                Save
                              </button>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  ))}
                </div>
              )}

              {selectedSection === "Members" && (
                <>
                  {selectedSection === "Functions" ||
                  "Roles & Responsibilites" ? (
                    <div className="committeeTableDiv">
                      <div className="committeSearchDiv">
                        <input
                          type="text"
                          placeholder="MemberName..."
                          value={search}
                          onChange={(e) => handleSearch(e)}
                        />
                      </div>
                      <table className="tableStylings">
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Name</th>
                            <th>Position</th>
                            <th>Type</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paginationData &&
                            paginationData.length > 0 &&
                            paginationData.map((items, index) => {
                              return (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  {editableIndex === index ? (
                                    <td>
                                      <input
                                        type="text"
                                        name="CommiteeName"
                                        value={modifyDataMembers.name}
                                        onChange={(e) => {
                                          setModifyDataMembers({
                                            ...modifyDataMembers,
                                            name: e.target.value,
                                          });
                                        }}
                                        className="cordinator_input"
                                      />
                                    </td>
                                  ) : (
                                    <td>{items.name}</td>
                                  )}
                                  {editableIndex === index ? (
                                    <td>
                                      {" "}
                                      <input
                                        type="text"
                                        name="CordinatorName"
                                        value={modifyDataMembers.position}
                                        className="cordinator_input"
                                        onChange={(e) => {
                                          setModifyDataMembers({
                                            ...modifyDataMembers,
                                            position: e.target.value,
                                          });
                                        }}
                                      />
                                    </td>
                                  ) : (
                                    <td> {items.position} </td>
                                  )}
                                  {editableIndex === index ? (
                                    <td>
                                      {" "}
                                      <input
                                        type="text"
                                        name="CordinatorName"
                                        value={modifyDataMembers.type}
                                        className="cordinator_input"
                                        onChange={(e) => {
                                          setModifyDataMembers({
                                            ...modifyDataMembers,
                                            type: e.target.value,
                                          });
                                        }}
                                      />
                                    </td>
                                  ) : (
                                    <td> {items.type} </td>
                                  )}
                                  {editableIndex === index ? (
                                    <td>
                                      <button
                                        className="generalButton"
                                        onClick={() =>
                                          handleEditSubmitCommMemmers()
                                        }
                                      >
                                        Submit
                                      </button>
                                    </td>
                                  ) : (
                                    <td>
                                      <EditOutlinedIcon
                                        className="editIconCommitee"
                                        onClick={() => {
                                          handleClickForEditCommiteeMember();
                                          setModifyDataMembers(items);
                                          setEditableIndex(index);
                                        }}
                                      ></EditOutlinedIcon>
                                      <DeleteIcon
                                        className="deleteIcon"
                                        onClick={() =>
                                          handleDeleteCommiteeMem(items.rid)
                                        }
                                      />
                                    </td>
                                  )}
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                      <PaginationReUsable
                        paginationData={filteredData}
                        handleGetSpliceData={handleGetSpliceData}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}

      <React.Fragment>
        <Dialog
          open={openEdit}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleCloseEdit}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>{"Edit Committee"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <div className="containerPop">
                <label className="labelCommitee">Committee Name</label>
                <input
                  type="text"
                  name="CommiteeName"
                  value={modify.committees}
                  disabled
                  className="cordinator_input"
                />
                <label className="labelCommitee">Committee Co-Ordinator</label>
                <input
                  type="text"
                  name="CordinatorName"
                  value={modify.cordinator}
                  className="cordinator_input"
                  onChange={(e) => {
                    setModify({ ...modify, cordinator: e.target.value });
                  }}
                />
                <label className="labelCommitee">E-Mail</label>
                <input
                  type="text"
                  name="CordinatorEmail"
                  value={modify.cordinatorEmail}
                  onChange={(e) => {
                    setModify({ ...modify, cordinatorEmail: e.target.value });
                  }}
                  className="cordinator_input"
                />
                <label className="labelCommitee">Mobile Number</label>
                <input
                  type="number"
                  name="CordinatorContact"
                  value={modify.cordinatorMobileNumber}
                  onChange={(e) => {
                    setModify({
                      ...modify,
                      cordinatorMobileNumber: e.target.value,
                    });
                  }}
                  className="cordinator_input"
                />
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                handleCloseEdit();
              }}
              sx={{ color: "green" }}
            >
              submit
            </Button>
            <Button
              onClick={() => {
                handleCloseAndEdit();
              }}
              sx={{ color: "red" }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </>
  );
}
